export default {
  simulation: {
    header: 'Simulácia',
    secondsPerCalculationStepLabel: 'Rozlíšenie',
    secondsPerCalculationStepDescription: 'Simulovaný čas medzi dvoma po sebe nasledujúcimi výpočtovými krokmi',
    factorOnCBetaLabel: 'Faktor C-Beta',
    factorOnCBetaDescription: 'Upraviť koeficient prenosu uhlíka',
    factorOnCDiffCoeffLabel: 'Faktor na C-Diff-Koeff',
    factorOnCDiffCoeffDescription: 'Upraviť koeficient difúzie uhlíka',
    timeoutSeconds: 'Maximálny čas simulácie',
  },
  lowPressureCarburizingOnly: {
    header: 'Iba nízkotlakové cementovanie',
    maxCInCementiteLabel: 'Max C v cementite',
    maxCInCementiteDescription: 'Horná hranica hysterézy automatického dopĺňania',
    cBelowCarbidelimitLabel: 'C pod hranicou karbidov',
    cBelowCarbidelimitDescription: 'Dolná hranica hysterézy automatického dopĺňania',
  },
  showComponentSelectionWhenLoadingCheckbox: 'Zobraziť výber komponentov pri načítavaní',
};
